module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clear_selected":"Clear selected item"},"zh":{"clear_selected":"清除選取的項目"}}')
  delete Component.options._Ctor
}
